import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, Globe, ChevronDown } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

import ImagesPallet from '../../../utils/ImagesPallet';
import ColorPallet from '../../../utils/ColorPallet';

// Hairstudio Translations  
import IndonesianHairstudio from '../../../translations/navbar/hairstudio/Indonesian';  
import EnglishHairstudio from '../../../translations/navbar/hairstudio/English';  
import ChineseHairstudio from '../../../translations/navbar/hairstudio/Chinese';  
  
// Academy Translations  
import IndonesianAcademy from '../../../translations/navbar/academy/Indonesian';  
import EnglishAcademy from '../../../translations/navbar/academy/English';  
import ChineseAcademy from '../../../translations/navbar/academy/Chinese';  

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('beranda');
  const [language, setLanguage] = useState('id');
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [isOtherMenuOpen, setIsOtherMenuOpen] = useState(false);

   // Refs for dropdown menus
  const langMenuRef = useRef(null);
  const otherMenuRef = useRef(null);
  const langButtonRef = useRef(null);
  const otherButtonRef = useRef(null);

  const translationsHairstudio = {
    id: IndonesianHairstudio,
    en: EnglishHairstudio,
    cn: ChineseHairstudio,
  };

  const translationsAcademy = {
    id: IndonesianAcademy,
    en: EnglishAcademy,
    cn: ChineseAcademy,
  };

  // Route mapping
  const routeItemsHairstudio = {
    beranda: '/',
    visiMisi: '/mission-hairstudio',
    // cerita: '/story-hairstudio',
    tentangKami: '/about-hairstudio',
    lokasi: '/location-hairstudio',
    kontak: '/contactus-hairstudio',
    karir: '/careers',
    services: '/services-hairstudio',
    products: '/products-hairstudio',
    branch: '/branch-hairstudio',
    JakartaBranch: '/branch-hairstudio/jakarta-branch',
    ArizonaBranch: '/branch-hairstudio/arizona-branch',
  };

  const routeItemsAcademy = {
    beranda: '/academy',
    tentang: '/about-academy',
    visimisi: '/mission-academy',
    program: '/programs-academy',
    paket: '/packages-academy',
    pusatLatihan: '/training-center-academy',
    galeri: '/gallery-academy',
  };

  const getLogoText = () => {
    const path = location.pathname;
    // Jika di root path atau /hairstudio, tampilkan "Hairstudio"
    if (path === '/' || path.includes('hairstudio')) {
      return 'Hairstudio';
    }
    // Jika di path /academy, tampilkan "Academy"
    else if (path.includes('academy')) {
      return 'Academy';
    }
    // Default fallback
    return 'Hairstudio';
  };

  const isAcademyPage = location.pathname.includes('academy');

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (key) => {
    const routeItems = isAcademyPage ? routeItemsAcademy : routeItemsHairstudio; 
    if (routeItems[key]) {
      navigate(routeItems[key]);
      setActiveSection(key);
      setIsOpen(false);
    } else {
      if (location.pathname !== '/') {
        navigate('/');

        setTimeout(() => {
          const element = document.getElementById(key);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setActiveSection(key);
          } 
        }, 100);
      } else if (location.pathname !== '/academy') {
        navigate('/academy');

        setTimeout(() => {
          const element = document.getElementById(key);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setActiveSection(key);
          } 
        }, 100);
      } else {
        const element = document.getElementById(key);
        setTimeout(() => {
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setActiveSection(key);
          }
        }, 100)
      }
    }
    setIsOpen(false);
  };

  // Update active section based on current route
  useEffect(() => {
  // Handle route changes
  const handleRouteChange = () => {
    const path = location.pathname.replace('/', '');
    const routeItems = isAcademyPage ? routeItemsAcademy : routeItemsHairstudio;  

    if (path && Object.values(routeItems).includes('/' + path)) {
      setActiveSection(Object.keys(routeItems).find(key => routeItems[key] === '/' + path));
    }
  };

  // Handle clicks outside dropdown menus
  const handleClickOutside = (event) => {
    // Language menu
    if (isLangMenuOpen && 
        !langMenuRef.current?.contains(event.target) && 
        !langButtonRef.current?.contains(event.target)) {
      setIsLangMenuOpen(false);
    }
    
    // Other menu
    if (isOtherMenuOpen && 
        !otherMenuRef.current?.contains(event.target) && 
        !otherButtonRef.current?.contains(event.target)) {
      setIsOtherMenuOpen(false);
    }
  };

  // Initial route check
    handleRouteChange();

    // Add click outside listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [location, isLangMenuOpen, isOtherMenuOpen, isAcademyPage, langMenuRef, langButtonRef, otherMenuRef, otherButtonRef]);

  const switchLanguage = (lang) => {
    setLanguage(lang);
    setIsLangMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname === '/academy') {
      navigate('/academy');
    } else {
      navigate('/');
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  
    setActiveSection('beranda');
 
  }
  // Pilih menu berdasarkan halaman
  const translations = isAcademyPage ? translationsAcademy : translationsHairstudio;  

  

  return (
    <>
    <nav className="fixed w-full shadow-md z-50 " style={{ backgroundColor: ColorPallet.secondLightBrown}}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          
          {/* Logo */}
          <div 
            onClick={handleLogoClick}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <img
              src={ImagesPallet.HeroLogo}
              alt="HeroImage"
              className="rounded-lg w-[200px] sm:w-[250px]"
            />
            <span className="text-sm sm:text-lg md:text-xl text-white font-semibold">{getLogoText()}</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6">
              {Object.keys(translations[language]).map((key) => (
                key === 'lainnya' ? (
                  <div className="relative">
                    <button 
                      ref={otherButtonRef}
                      key={key}
                      onClick={() => setIsOtherMenuOpen(!isOtherMenuOpen)}
                      className="flex items-center space-x-1 text-white hover:hover:text-[#F3E3D3]"
                      aria-haspopup="true"  
                      aria-expanded={isOtherMenuOpen}
                    >
                      {translations[language][key]}<br/>
                      <ChevronDown size={16} />
                    </button>

                    {isOtherMenuOpen && (
                      <div ref={otherMenuRef} className="absolute right-0 mt-2 py-2 w-44 bg-white rounded-lg shadow-xl">
                        <a href={isAcademyPage ? "/" : "/academy"}>
                          <button
                          className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                        >
                          {isAcademyPage ? "Hairstudio" : "Akademi Hairstudio"} 
                          </button>
                        </a>
                        
                        {/* Academy */}
                        {isAcademyPage && (
                          <a href='/gallery-academy'>
                            <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                          >
                            Galeri
                            </button>
                          </a>
                          
                        )}

                        {isAcademyPage && (
                          <a href='/gallery-academy'>
                            <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                          >
                            FAQ
                            </button>
                          </a>
                          
                        )}
                        
                        {/* Hairstudio */}
                        {!isAcademyPage && (
                          <a href='/services-hairstudio'>
                            <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                          >
                            Services
                            </button>
                          </a>
                        )}

                        {!isAcademyPage && (
                          <a href='/products-hairstudio'>
                            <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                          >
                            Products
                            </button>
                          </a>

                        )}

                        {!isAcademyPage && (
                          <a href='/branch-hairstudio'>
                            <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                          >
                            Branch
                            </button>
                          </a>

                        )}
                        
                      </div>
                    )}
                  </div>
                ) : (
                  <button 
                  key={key}
                  onClick={() => handleNavigation(key)}
                  className={` hover:text-[#F3E3D3] transition ${
                    activeSection === key ? 'text-purple-400 font-bold' : 'text-white'
                  }`}
                >
                  {translations[language][key]}
                </button>
                )
              ))}

            {/* Language Switcher */}
            <div className="relative">
                <button 
                ref={langButtonRef}
                onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                  className="flex items-center space-x-1 text-white hover:hover:text-[#F3E3D3]"
                  aria-haspopup="true"  
                  aria-expanded={isLangMenuOpen}  
              >
                <Globe size={20} />
                <span>{language.toUpperCase()}</span>
                <ChevronDown size={16} />
              </button>

              {isLangMenuOpen && (
                <div ref={langMenuRef} className="absolute right-0 mt-2 py-2 w-32 bg-white rounded-lg shadow-xl">
                  <button
                    onClick={() => switchLanguage('id')}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                  >
                    Indonesia
                  </button>
                  <button
                    onClick={() => switchLanguage('en')}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                  >
                    English
                  </button>
                  <button
                    onClick={() => switchLanguage('cn')}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-purple-600"
                  >
                    China
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center">
            <button 
              onClick={toggleMenu} 
              className="text-white hover:text-[#F3E3D3] transition-colors duration-200 p-2 rounded-lg focus:outline-none"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden absolute top-16 left-0 right-0 bg-white shadow-lg rounded-b-lg overflow-hidden">
            <div className="px-4 py-3 space-y-2">
              {Object.keys(translations[language]).map((key) => (
                key === 'lainnya' ? (
                  <div key={key} className="relative py-2">
                    <button 
                      onClick={() => setIsOtherMenuOpen(!isOtherMenuOpen)}
                      className="flex items-center justify-between w-full px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200"
                    >
                      <span>{translations[language][key]}</span>
                      <ChevronDown size={16} className={`transform transition-transform duration-200 ${isOtherMenuOpen ? 'rotate-180' : ''}`} />
                    </button>
                    
                    {isOtherMenuOpen && (
                      <div className="mt-2 pl-4 space-y-2">
                        <a href={isAcademyPage ? "/" : "/academy"}>
                          <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                            {isAcademyPage ? "Hairstudio" : "Akademi Hairstudio"}
                          </button>
                        </a>
                        
                        {isAcademyPage ? (
                          <>
                            <a href='/gallery-academy'>
                              <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                                Galeri
                              </button>
                            </a>
                            <a href='/gallery-academy'>
                              <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                                FAQ
                              </button>
                            </a>
                          </>
                        ) : (
                          <>
                            <a href='/services-hairstudio'>
                              <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                                Services
                              </button>
                            </a>
                            <a href='/products-hairstudio'>
                              <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                                Products
                              </button>
                            </a>
                            <a href='/branch-hairstudio'>
                              <button className="w-full text-left px-4 py-2 text-[#BC785B] hover:bg-amber-50 rounded-lg transition-colors duration-200">
                                Branch
                              </button>
                            </a>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <button 
                    key={key}
                    onClick={() => handleNavigation(key)}
                    className={`w-full text-left px-4 py-2 rounded-lg transition-colors duration-200 
                      ${activeSection === key 
                        ? 'bg-amber-50 text-[#BC785B] font-semibold' 
                        : 'text-[#BC785B] hover:bg-amber-50'}`}
                  >
                    {translations[language][key]}
                  </button>
                )
              ))}

              {/* Mobile Language Switcher */}
              <div className="px-4 py-3 border-t border-gray-200">
                <div className="flex justify-center gap-4">
                  {['id', 'en', 'cn'].map((lang) => (
                    <button
                      key={lang}
                      onClick={() => switchLanguage(lang)}
                      className={`px-4 py-2 rounded-lg transition-colors duration-200 
                        ${language === lang 
                          ? 'bg-[#BC785B] text-white' 
                          : 'text-[#BC785B] hover:bg-amber-50'}`}
                    >
                      {lang.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;